import styled, { css, keyframes } from 'styled-components/macro';
import { getDSColor, hexToRGB } from '../theme';
import { SkeletonProps } from './types';

const shimmer = keyframes`
  100% {
    transform: translateX(100%);
  }
`;

export const SkeletonWrapper = styled.div<SkeletonProps>`
  top: 0;
  left: 0;
  display: inline-block;
  overflow: hidden;

  ${({
    theme,
    flex,
    overlay,
    overlayBackground,
    borderRadius,
    width,
    height,
  }) => {
    const baseColor = overlayBackground
      ? getDSColor(theme, overlayBackground)
      : theme.colors.white;

    const gradient = `
      linear-gradient(
        90deg,
        ${hexToRGB(baseColor, 0)} 0%,
        ${hexToRGB(baseColor, 0.2)} 20%,
        ${hexToRGB(baseColor, 0.6)} 60%,
        ${hexToRGB(baseColor, 0)} 100%
      )
    `;

    return css`
      flex: ${flex ?? 'initial'};
      position: ${overlay ? 'absolute' : 'relative'};
      width: ${width || (overlay ? '100%' : 'auto')};
      height: ${height || (overlay ? '100%' : '32px')};
      background-color: ${overlay ? 'transparent' : theme.colors.gray[100]};
      border-radius: ${borderRadius === 'full' ? 9999 : borderRadius || 8}px;

      &::after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        transform: translateX(-100%);
        animation: ${shimmer} 1.6s infinite;
        background: ${gradient};
      }
    `;
  }};
`;
